const product = [
    {
        "code": "TAF-QP110004",
        "category": "QP",
        "name": "產品驗證機構認證規範ISO/IEC 17065訓練",
        "classDate": "2021/12/21~2021/12/22",
        "studentQualification": "適用於產品驗證工作之相關人員及有興趣者。",
        "firstCourse": "",
        "enrollment": "30",
        "enrollmentStatus": "accept",
        "enrollmentType": "enrollment",
        "location": "台北",
        "cost": "新台幣5500",
        "description": "國際標準組織(International Organization for Standardization, ISO)於2012年9月15日正式公布「ISO/IEC 17065:2012符合性評鑑－產品、過程與服務驗證機構之要求」，並表示此標準將取代1995年發行之「ISO/IEC Guide 65－執行產品驗證系統機構之一般要求」。\n" +
            "此標準之改版更新，亦代表國內以及國際間原本依據「ISO/IEC Guide 65」建立產品驗證能力之驗證機構將首當其衝面臨符合性適用標準之轉換，並應儘早著手針對其內部架構、能力資源以及管理系統等重新檢討及調整，以滿足新版標準以及國際間之共識要求。" +
            "另一方面，國內相關權責機關基於保障人民福祉、健康及安全等考量因素下，亦陸續針對相關產品標的進行立法管制甚而參考國際標準之要求，納入第三者產品驗證機構之管理機制。於此政策下，市場對於產品驗證機構之需求將不斷提升，但是否有足夠且合格的產品驗證機構得以因應此市場及政策之需求亦將是一大問題。\n" +
            "全國認證基金會有感於此，特依據辦理多年產品驗證機構認證，以及參與國際認證論壇等相關會議之經驗，規劃公開辦理ISO/IEC 17065研討會。" +
            "本研討會之規劃與設計以2天的一般課程為主，並非針對特定對象量身訂製之顧問輔導課程。" +
            "課程之進行主要係依據ISO/IEC 17065標準條文之解析，以及該標準在產品驗證認證評鑑實務之應用，來說明產品驗證機構在建置其驗證系統時，應具備之基本認知；同時配合案例之討論，期能使參加人員深入了解ISO/IEC 17065之精神與要求，以協助有意運作產品驗證之機構能自行完成規劃，建立適用的、有效的，且讓消費者或採購商有信心的之產品驗證系統。\n" +
            "全程參加且經測驗合格者，可獲頒本會ISO/IEC 17065訓練合格證書。",
        "outline": "課程大綱\n" +
            "分以下四個單元\n" +
            "一、符合性評鑑與認證驗證簡介\n" +
            "二、ISO/IEC 17065標準條文解說與研析\n" +
            "三、案例研討與實作\n" +
            "四、課後測驗",
        "remark": "★實體課程，請注意下列事項\n" +
            "1.疫情期間，將視疫情狀況調整人數。\n" +
            "2.本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3.若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4.參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$5,200(含稅)。"
    },
];

export default product;